module.exports = __webpack_public_path__ + "img/thumbapron2.66c54a2e.png";